import { useEffect } from "react";
import WaterlooHeroSection from "./components/HeroSection";
import WaterlooStickyNav from "./components/StickyNav";
import WaterlooProcessingTimeSection from "./components/ProcessingTimeSection";
import WaterlooServicesSection from "./components/ServicesSection";
import WaterlooLocalAreaSection from "./components/LocalAreaSection";
import WaterlooTestimonialsSection from "./components/TestimonialsSection";
import WaterlooAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WaterlooComparisonSection from "./components/ComparisonSection";
import WaterlooMistakesSection from "./components/MistakesSection";
import WaterlooHowItWorksSection from "./components/HowItWorksSection";
import WaterlooFAQSection, { faqs } from "./components/FAQSection";
import WaterlooHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WaterlooFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function WaterlooPage() {
  useEffect(() => {
    document.title = "Emergency Passport Waterloo IA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/waterloo-ia/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Waterloo, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Black Hawk County, Cedar Falls, UNI students, John Deere employees, and Northeast Iowa families.");
    setMeta("geo.placename", "Waterloo, Iowa");
    setMeta("geo.region", "US-IA");
    setMeta("geo.position", "42.4928;-92.3426");
    setMeta("ICBM", "42.4928, -92.3426");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Iowa", item: "https://fastpassportcenter.com/iowa/" },
          { "@type": "ListItem", position: 3, name: "Waterloo Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Waterloo, Cedar Falls, and Northeast Iowa residents. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Waterloo", containedInPlace: { "@type": "State", name: "Iowa" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <WaterlooHeroSection />
      <WaterlooStickyNav />
      <WaterlooProcessingTimeSection />
      <WaterlooServicesSection />
      <WaterlooLocalAreaSection />
      <WaterlooTestimonialsSection />
      <WaterlooAcceptanceFacilitiesSection />
      <WaterlooComparisonSection />
      <WaterlooMistakesSection />
      <WaterlooHowItWorksSection />
      <WaterlooFAQSection />
      <WaterlooHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/waterloo-ia" state="IA" />
      <WaterlooFinalCTA />
    </div>
  );
}